import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {Row, Col, Navbar, Button, ButtonGroup} from 'reactstrap';

import MagstimNavBarBrand from './MagstimNavBarBrand';

// import { styles } from "./magstim";
import '../html/fontawesome/css/all.min.css';
import { MagstimColor } from "./../Magstim.Color";
import { CurrentTheme } from "common/utils/ThemeUtils";
import { magstim_eventHandler } from "./magstim";


class MagstimAccordionHeader extends React.Component {

    handleClick(value) {
        magstim_eventHandler("click", value, null, this.magstim_eventHandler_callback);
    }

    // eslint-disable-next-line no-unused-vars
    actionOnClick = (event) => {
        this.handleClick(this.props.add_id);
    }

    // eslint-disable-next-line no-unused-vars
    toggleOnClick = (event) => {
        // Pass back the eventKey
        this.props.toggleOnClick(this.props.eventKey);
    }

    magstim_eventHandler_callback = (eventName, value, additionalData) =>{
		if(this.props.magstim_eventHandler_callback){
			this.props.magstim_eventHandler_callback(eventName, value, additionalData);
		}
	}

    render() {
        return (
            <Wrapper>
                    <Row>
                        <Col md={8} xs={12}>
                            <Navbar expand="lg"  >
                                <MagstimNavBarBrand main_icon={this.props.main_icon} main_title={this.props.main_title} />
                            </Navbar>
                        </Col>

                        <Col md={4} xs={12}>
                            <ButtonGroup className="float-right mr-3">
                                <Button size={CurrentTheme().ControlSize} color="primary" onClick={this.actionOnClick}>
                                    <i className="fas fa-plus"></i>
                                    {this.props.add_title}
                                </Button>

                                <Button size={CurrentTheme().ControlSize} color="primary"  onClick={this.toggleOnClick}>
                                    {!this.props.isOpen && <i className="fas fa-chevron-down"></i>}
                                    {this.props.isOpen && <i className="fas fa-chevron-up"></i>}
                                </Button>
                            </ButtonGroup>
                        </Col>

                    </Row>
            </Wrapper>
        );
    }
}

MagstimAccordionHeader.propTypes = {
    main_title: PropTypes.string,
    main_icon: PropTypes.string,
    addTitle: PropTypes.string,
    isOpen: PropTypes.bool,
    add_id: PropTypes.string,
    toggleOnClick: PropTypes.func,
    eventKey: PropTypes.number,
    add_title: PropTypes.string
};

MagstimAccordionHeader.defaultProps = {
    main_title: '',
    main_icon: ''
};

const Wrapper = styled.div`

fofont-family: 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
font-size: 18px;
font-weight: bold;
color: ${ MagstimColor.MagstimGroupHeaderText};
background-color: ${ MagstimColor.MagstimCardHeaderBackground};
border-color: ${ MagstimColor.MagstimCardHeaderBackground};
border-radius:0.25em;

`;

export default MagstimAccordionHeader;